<template>
  <!-- Obal s rámečkem -->
  <div class="empty-state">
    <div class="empty-state__frame">
      <img :src="frameImg" alt="" class="empty-state__frame-img">
      <div class="empty-state__content">
        <img v-if="icon" :src="icon" alt="" class="empty-state__icon" :style="iconStyle">
        <p class="empty-state__title">{{ title }}</p>
        <p v-if="text" class="empty-state__text">{{ text }}</p>
      </div>
    </div>
    <div v-if="$slots.default" class="empty-state__action">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import frameImg from '/public/img/new-design/Frame_grey.svg';

export default {
  props: {
    icon: {
      type: String,
      default: null,
    },
    iconStyle: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      frameImg,
    };
  },
};
</script>